import { LocationConstants } from '../constants';

export function locationReducer(state = {}, action) {
    switch (action.type) {
        case LocationConstants.GETALL_LOCATIONS_REQUEST:
            return {
                loading: true
            };
        case LocationConstants.GETALL_LOCATIONS_SUCCESS:
            return {
                items: action.locations
            };
        case LocationConstants.GETALL_LOCATIONS_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}